var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.031 2.46895C17.1008 2.53862 17.1562 2.62138 17.194 2.7125C17.2318 2.80362 17.2513 2.9013 17.2513 2.99995C17.2513 3.0986 17.2318 3.19629 17.194 3.2874C17.1562 3.37852 17.1008 3.46128 17.031 3.53095L8.56045 12L17.031 20.469C17.1718 20.6098 17.2509 20.8008 17.2509 21C17.2509 21.1991 17.1718 21.3901 17.031 21.531C16.8901 21.6718 16.6991 21.7509 16.5 21.7509C16.3008 21.7509 16.1098 21.6718 15.969 21.531L6.96895 12.531C6.89911 12.4613 6.84369 12.3785 6.80588 12.2874C6.76807 12.1963 6.74861 12.0986 6.74861 12C6.74861 11.9013 6.76807 11.8036 6.80588 11.7125C6.84369 11.6214 6.89911 11.5386 6.96895 11.469L15.969 2.46895C16.0386 2.39911 16.1214 2.34369 16.2125 2.30588C16.3036 2.26807 16.4013 2.24861 16.5 2.24861C16.5986 2.24861 16.6963 2.26807 16.7874 2.30588C16.8785 2.34369 16.9613 2.39911 17.031 2.46895Z",
    fill: "#000099"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.ce785713ca65fb1da25ba21cafcc7da7.svg";
export { ForwardRef as ReactComponent };